import { render, staticRenderFns } from "./ExtrasCard.vue?vue&type=template&id=0766983b&"
import script from "./ExtrasCard.vue?vue&type=script&lang=js&"
export * from "./ExtrasCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports